import AppConstants from "../constants/AppConstants";
import { getJWTToken } from "../utils/helpers.utils"

export const emptySessionStorage = () => {
  sessionStorage.setItem("token", "");
  sessionStorage.setItem("username", "");
  sessionStorage.setItem("name", "");
  sessionStorage.setItem("role", "[]");
  sessionStorage.setItem("images", "");
  sessionStorage.setItem(AppConstants.COUNTRY_CODE, "");
  sessionStorage.removeItem(AppConstants.UAC_CACHE_KEY);
};

// Cache of the last successfully fetched UAC data for the current session, used as a
// fallback if a later access-control call fails (e.g. transient outage) so the app
// doesn't lose previously-granted permissions. Cleared on every new login attempt and
// on logout so a failure never falls back to a different user's permissions.
export const cacheUacData = (uacData: any) => {
  try {
    if (uacData) {
      sessionStorage.setItem(AppConstants.UAC_CACHE_KEY, JSON.stringify(uacData));
    }
  } catch {
    // sessionStorage unavailable/full - caching is best-effort only
  }
};

export const getCachedUacData = (): any => {
  try {
    const cached = sessionStorage.getItem(AppConstants.UAC_CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch {
    return null;
  }
};

export const setSessionStorage = (payload: any) => {
  const token = `Bearer ${ getJWTToken(payload)}`;
  sessionStorage.setItem("token", token);
  sessionStorage.setItem("username", payload?.username);
  sessionStorage.setItem("name", payload?.name);
  sessionStorage.setItem("role", JSON.stringify(payload?.roles));
  sessionStorage.setItem("images", JSON.stringify(payload?.images || ""));
  sessionStorage.setItem(AppConstants.COUNTRY_CODE, payload?.countryCode);
};
